define(['debugService', 'baseApi'], function (debugService, baseApi) {
  var _debug = false; // NOTICE: 调试选项, 发布前必须关闭

  var _initDocumentEventHandles = function () {
    var filterSelect = {'INPUT':true, 'TEXTAREA': true};

    if (!_debug) {
      //屏蔽右键菜单
      document.oncontextmenu = function (e){
        var e = e || event;
        e.returnValue = false;
      };
      //屏蔽选中
      document.onselectstart = function (e) {
        var e = e || event,
          element = e.srcElement;
        if(e) {
          if (filterSelect[element.tagName]) {
            return true;
          }
        }
        return false;
      };
    }

    //屏蔽图片拖动
    document.ondragstart = function (e){
      var e = e || event,
        element = e.srcElement;
      if(e) {
        if (filterSelect[element.tagName]) {
          return true;
        }
      }

      return false;
    };

    document.onkeydown = function (e) {
      if (e.keyCode === 9) {
        return false;
      }
    };

    window.alert = () => {};
  };

  var _initDebugService = function () {
    if (_debug) {
      debugService.init();
    }
  };

  // TODO
  return function () {
    if (baseApi.isWpsEnv()) {
      _initDocumentEventHandles();
      _initDebugService();
    }
  };
});



/** WEBPACK FOOTER **
 ** ./src/scripts/appInit.js
 **/